import { useMemo } from 'react';

export interface RegexValidation {
  regexes: RegExp[];
  errorMessage: string;
}

interface UseValidateByRegexOptions {
  value: string;
  validations: RegexValidation[];
}

/**
 * Validates a string against multiple regex patterns and returns matching error messages.
 * @param value - The string to validate
 * @param validations - Array of regex array-error message pairs to test against
 * @returns Array of error messages for validation groups where at least one regex matched the input
 */
export function useValidateByRegex({
  value,
  validations
}: UseValidateByRegexOptions): string[] {
  return useMemo(() => {
    return validations?.length > 0 ?
        validations
          .filter(({ regexes }) => regexes.some((regex) => regex.test(value)))
          .map(({ errorMessage }) => errorMessage)
      : [];
  }, [value, validations]);
}